import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import CustomReportShow from '../components/report/CustomReportShow';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ customReport, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <CustomReportShow
          intl={intl}
          dispatch={dispatch}
          customReport={customReport}
          loading={loading}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/CustomReportShow.js